<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-11-17 13:29:51
 * @FilePath: /mrc-ess-fronted/src/Page/EssAdmin/Roster/RosterRecord/components/ErrorMessage.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-05-27 10:45:52
-->
<template>
  <normalDialog
    :dialog="show"
    width="800"
    :title="$t('label_essweb_RosterRecord_dialog_errorMessageTitle')"
    maxWidth="800"
    @close="closeDialog"
  >
    <template v-slot:content>
      <Tabler :headers="headers" :items="desserts">
        <template v-slot:item.position="{ item }"> {{ item.cell }}</template>
        <template v-slot:item.message="{ item }"> {{ item.msg }}</template>
      </Tabler>
    </template>
    <template v-slot:actions>
      <CardActions
        saveBtn
        saveText="label_essweb_rosterRecord_dialog_downErrorBtnLabel"
        @save="toUrl"
        @cancel="closeDialog"
      />
    </template>
  </normalDialog>
</template>
<script>
export default {
  name: "ErrorMessage",
  data() {
    return {
      headers: [
        {
          text: "label_essweb_import_errorlist_positionLabel",
          value: "position",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_import_errorlist_messageLabel",
          value: "message",
          align: "start",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  props: {
    show: { default: false, type: Boolean },
    items: { default: [], type: Array },
    downloadUrl: { default: "", type: [String, Number] },
  },
  watch: {
    items(val) {
      this.desserts = val;
    },
  },
  methods: {
    toUrl: function () {
      if (this.downloadUrl) location.href = this.downloadUrl;
    },
    closeDialog: function () {
      this.$emit("close");
    },
  },
};
</script>